import { useEffect } from "react"
import { Link } from "@mui/material"

const HelpButton = () => {
    
    const onPress = () => {

        window?.smartsupp('variables', {
            Sistema: "IR Autofactura",
        })
        window?.smartsupp('chat:show')
        window?.smartsupp('chat:open')
    }

    useEffect(() => {
        try{
            setTimeout(() => {
                window?.smartsupp('chat:hide')
            }, 1000)
        }catch(e){
            console.log(e)
        }
        // eslint-disable-next-line
    },[])

    return (
        <Link 
            component='button' 
            variant="subtitle2" 
            color="inherit"
            onClick={onPress}
        >
            ¿Necesitas Ayuda?
        </Link>
    )
}

export { HelpButton }